import UInput from './UInput'
import UInputs from './UInputs'
import USelect from './USelect'
import UButton from './UButton'
import UCheckbox from './UCheckbox'
import URadio from './URadio'
import URadios from './URadios'

export default {
    install(app) {
        app.component("UFormInput", UInput)
        app.component("UFormInputs", UInputs)
        app.component("UFormSelect", USelect)
        app.component("UFormButton", UButton)
        app.component("UFormCheckbox", UCheckbox)
        app.component("UFormRadio", URadio)
        app.component("UFormRadios", URadios)
    }
}
